import { ArrowLeft } from 'lucide-react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@doger/ui/components/ui/card';
import { Link } from '@doger/ui/components/ui/link';

import { useAuthContext } from '../auth.context';
import { ForgotPasswordForm } from './forgot-password-form.component';
import styles from './forgot-password-page.module.scss';

type ForgotPasswordPageProps = {
  onSuccess?: () => void;
};

export const ForgotPasswordPage = memo(
  ({ onSuccess }: ForgotPasswordPageProps) => {
    const { signInUrl } = useAuthContext();
    const { t } = useTranslation('core');

    return (
      <div className={styles.container}>
        <Card className={styles.card}>
          <CardHeader>
            <CardTitle>{t('auth.forgotPassword.title')}</CardTitle>
            <CardDescription>
              {t('auth.forgotPassword.description')}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <ForgotPasswordForm onSuccess={onSuccess} />

            <div className={styles.links}>
              <Link className={styles.link} to={signInUrl}>
                <ArrowLeft />
                {t('auth.navigation.backToSignIn')}
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
);

ForgotPasswordPage.displayName = 'ForgotPasswordPage';
